let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("68Kzv"), load("3NvtU"), load("7FkEF"), load("dvReR"), load("5J0Y3")]).then(() => parcelRequire('1jMgA'));